import React, { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import RippleLoader from "../commons/RippleLoader";
const DefaultLayout = lazy(() => import("../layouts"));
const Auth = lazy(() => import("../pages/auth/Auth"));
const Profile = lazy(() => import("../pages/userDetails/Profile"));
const Page404 = lazy(() => import("../commons/Page404"));
const Page500 = lazy(() => import("../commons/Page500"));
const ResetPassword = lazy(() => import("../pages/auth/ResetPassword"));
const NewPassword = lazy(() => import("../pages/auth/NewPassword"));
const PasswordSuccessful = lazy(() =>
  import("../pages/auth/PasswordSuccessful")
);
const RoleAccess = lazy(() => import("../pages/accounts/RoleAccess"));
const StaffAccounts = lazy(() => import("../pages/accounts/StaffAccounts"));
const CreateEditStaffAccount = lazy(() =>
  import("../pages/accounts/CreateEditStaffAccount")
);
const Customers = lazy(() => import("../pages/customers/Customers"));
const CreateEditCustomers = lazy(() =>
  import("../pages/customers/createEditCustomers/CreateEditCustomers")
);
const Notifications = lazy(() =>
  import("../pages/notifications/Notifications")
);
const Companies = lazy(() => import("../pages/companies/Companies"));
const CreateEditCompany = lazy(() =>
  import("../pages/companies/createEditCompany/CreateEditCompany")
);
const Broadcast = lazy(() => import("../pages/broadcast/Broadcast"));
const CreateEditBroadcast = lazy(() =>
  import("../pages/broadcast/CreateEditBroadcast")
);
const Sales = lazy(() => import("../pages/sales/Sales"));
const CompanyProfile = lazy(() =>
  import("../pages/companies/viewCompany/CompanyProfile")
);
const EditCompanySubscription = lazy(() =>
  import("../pages/sales/EditCompanySubscription")
);
const ServiceSetting = lazy(() =>
  import("../pages/masterSetting/serviceSetting/ServiceSetting")
);
const EditSetting = lazy(() =>
  import("../pages/masterSetting/serviceSetting/EditSetting")
);
const GeneralSetting = lazy(() =>
  import("../pages/masterSetting/generalSetting/GeneralSetting")
);
const Accounting = lazy(() =>
  import("../pages/masterSetting/serviceSetting/Accounting")
);
const ActivityLog = lazy(() => import("../pages/activityLog/ActivityLog"));
const CreateServiceRequestSales = lazy(() =>
  import("../pages/sales/CreateServiceRequestSales")
);
const CreateSubscription = lazy(() =>
  import("../pages/sales/CreateSubscription")
);
const Chat = lazy(() => import("../pages/chat/Chat"));
const SalesView = lazy(() => import("../pages/sales/SalesView"));
const EditSubscription = lazy(() =>
  import("../pages/masterSetting/generalSetting/EditSubscription")
);
const ServiceRequest = lazy(() =>
  import("../pages/serviceRequest/ServiceRequest")
);
const Tickets = lazy(() => import("../pages/tickets/Tickets"));
const ChatUI = lazy(() =>
  import("../pages/serviceRequest/request/OpenRequest")
);
const ServiceRequestDetails = lazy(() =>
  import("../pages/serviceRequest/request/ServiceRequestDetails")
);
const SalesReport = lazy(() => import("../pages/report/SalesReport"));
const CreateServiceRequest = lazy(() =>
  import("../pages/serviceRequest/CreateServiceRequest")
);
const LocalDirector = lazy(() =>
  import("../pages/serviceRequest/components/LocalDirector")
);
const OpenBankAccount = lazy(() =>
  import("../pages/serviceRequest/components/OpenBankAccount")
);
const ChangeCompanyName = lazy(() =>
  import("../pages/serviceRequest/components/ChangeCompanyName")
);
const ChangeBusinessActivities = lazy(() =>
  import("../pages/serviceRequest/components/ChangeBusinessActivities")
);
const CloseBankAccount = lazy(() =>
  import("../pages/serviceRequest/components/CloseBankAccount")
);
const ChangeCompanyRegisteredAddress = lazy(() =>
  import("../pages/serviceRequest/components/ChangeCompanyRegisteredAddress")
);
const ChangeDirectorParticulars = lazy(() =>
  import("../pages/serviceRequest/components/ChangeDirectorParticulars")
);
const ChangeShareholdersParticulars = lazy(() =>
  import("../pages/serviceRequest/components/ChangeShareholdersParticulars")
);
const ChangeFinancialYearEnd = lazy(() =>
  import("../pages/serviceRequest/components/ChangeFinancialYearEnd")
);
const AllotmentTransferNewShareholder = lazy(() =>
  import("../pages/serviceRequest/components/AllotmentTransferNewShareholder")
);
const ApplyingForPasses = lazy(() =>
  import("../pages/serviceRequest/components/ApplyingForPasses")
);
const SubscriptionReport = lazy(() =>
  import("../pages/report/SubscriptionReport")
);
const CompaniesReport = lazy(() => import("../pages/report/CompaniesReport"));
const TicketsReport = lazy(() => import("../pages/report/TicketsReport"));
const ServiceRequestReport = lazy(() =>
  import("../pages/report/ServiceRequestReport")
);
const Dashboard = lazy(() => import("../pages/dashboard/Dashboard"));

const AppRoutes = () => {
  return (
    <>
      <ToastContainer position="bottom-right" theme="colored" />
      <Suspense fallback={<RippleLoader />}>
        <Routes>
          {/* Auth */}
          <Route exact path="/login" status={401} element={<Auth />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/new-password/:email/:token" element={<NewPassword />} />
          <Route path="/password-successful" element={<PasswordSuccessful />} />

          {/* DefaultLayout */}
          <Route path="/" element={<DefaultLayout />}>
            {/* Dashboard */}
            <Route index exact element={<Dashboard />} />
            {/* Accounts */}
            <Route exact path="/role-access" element={<RoleAccess />} />
            <Route exact path="/staff-accounts" element={<StaffAccounts />} />
            <Route
              exact
              path="/create-edit-staff-account"
              element={<CreateEditStaffAccount />}
            />
            {/* Profile */}
            <Route exact path="/profile" element={<Profile />} />
            {/* Customers */}
            <Route exact path="/customers" element={<Customers />} />
            <Route
              exact
              path="/create-edit-customers"
              element={<CreateEditCustomers />}
            />
            {/* Companies */}
            <Route exact path="/companies" element={<Companies />} />
            <Route
              exact
              path="/create-edit-company"
              element={<CreateEditCompany />}
            />
            <Route exact path="/view-company" element={<CompanyProfile />} />
            {/* Notifications */}
            <Route exact path="/notifications" element={<Notifications />} />
            {/* Broadcast */}
            <Route exact path="/broadcast" element={<Broadcast />} />
            <Route
              exact
              path="/create-edit-broadcast"
              element={<CreateEditBroadcast />}
            />
            {/* Sales */}
            <Route exact path="/sales" element={<Sales />} />
            <Route exact path="/sales_view" element={<SalesView />} />
            <Route
              exact
              path="/create-service-request-sales"
              element={<CreateServiceRequestSales />}
            />
            <Route
              exact
              path="/create-subscription"
              element={<CreateSubscription />}
            />
            <Route
              exact
              path="/edit-subscription-sales"
              element={<EditCompanySubscription />}
            />
            {/* Master Setting */}
            <Route
              exact
              path="/general-settings"
              element={<GeneralSetting />}
            />
            <Route
              exact
              path="/edit-subscription"
              element={<EditSubscription />}
            />
            <Route
              exact
              path="/service-settings"
              element={<ServiceSetting />}
            />
            <Route exact path="/edit-service" element={<EditSetting />} />
            <Route exact path="/accounting" element={<Accounting />} />
            {/* Activity Log */}
            <Route exact path="/activity-log" element={<ActivityLog />} />
            {/* Chat */}
            <Route exact path="/chat" element={<Chat />} />
            {/* Service Request */}
            <Route exact path="/service-request" element={<ServiceRequest />} />
            {/* Create Service Request */}
            <Route
              exact
              path="/create-service-request"
              element={<CreateServiceRequest />}
            />
            <Route
              exact
              path="/appointment_of_new_local_director"
              element={<LocalDirector />}
            />
            <Route
              exact
              path="/appointment_of_new_foreign_director"
              element={<LocalDirector />}
            />
            <Route
              exact
              path="/open_bank_account"
              element={<OpenBankAccount />}
            />
            <Route
              exact
              path="/change_of_company_name"
              element={<ChangeCompanyName />}
            />
            <Route
              exact
              path="/change_of_business_activities"
              element={<ChangeBusinessActivities />}
            />
            <Route
              exact
              path="/close_bank_account"
              element={<CloseBankAccount />}
            />
            <Route
              exact
              path="/change_of_company_registered_address"
              element={<ChangeCompanyRegisteredAddress />}
            />
            <Route
              exact
              path="/change_of_directors_particulars"
              element={<ChangeDirectorParticulars />}
            />
            <Route
              exact
              path="/change_of_shareholders_particulars"
              element={<ChangeShareholdersParticulars />}
            />
            <Route
              exact
              path="/change_of_financial_year_end"
              element={<ChangeFinancialYearEnd />}
            />
            <Route
              exact
              path="/allotment_transfer_of_shares"
              element={<AllotmentTransferNewShareholder />}
            />
            <Route
              exact
              path="/applying_for_passes"
              element={<ApplyingForPasses />}
            />

            <Route
              exact
              path="/service-request-details"
              element={<ServiceRequestDetails />}
            />
            <Route exact path="/ChatUI" element={<ChatUI />} />
            {/* Tickets */}
            <Route exact path="/tickets" element={<Tickets />} />
            {/* Report */}
            <Route
              exact
              path="/companies-report"
              element={<CompaniesReport />}
            />
            <Route exact path="/sales-report" element={<SalesReport />} />
            <Route
              exact
              path="/service-request-report"
              element={<ServiceRequestReport />}
            />
            <Route
              exact
              path="/subscriptions-report"
              element={<SubscriptionReport />}
            />
            <Route exact path="/tickets-report" element={<TicketsReport />} />
            {/* Page 404 */}
            <Route
              exact
              path="*"
              name="Page 404"
              status={404}
              element={<Page404 />}
            />
            {/* Page 500 */}
            <Route
              exact
              path="/500"
              name="Page 500"
              status={500}
              element={<Page500 />}
            />
          </Route>
        </Routes>
      </Suspense>
    </>
  );
};

export default AppRoutes;
